import { render } from "./TEIElement.vue?vue&type=template&id=08b8ed73&scoped=true"
import script from "./TEIElement.vue?vue&type=script&lang=js"
export * from "./TEIElement.vue?vue&type=script&lang=js"

import "./TEIElement.vue?vue&type=style&index=0&id=08b8ed73&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b8ed73"]])

export default __exports__